import { noteSelectionRegenerateOutput } from '@/lib/analytics/scribe/document';
import {
  noteGeneratedByAskAI,
  noteGeneratedByPressAICommand,
  noteGeneratedByTemplate,
} from '@/lib/analytics/scribe/note';
import {
  sessionTemplateUpdated,
  sessionVoiceUpdated,
} from '@/lib/analytics/scribe/session';
import { GenerationMethod, type VoiceStyle } from '@heidi/schema/ml-scribe';

export type CompletedGenerationAnalyticsInput = {
  isRegenerate?: boolean;
  voiceStyle?: VoiceStyle | null;
  oldVoiceStyle?: VoiceStyle;
  generationMethod?: GenerationMethod;
  templateId?: string | null;
  aiCommandText?: string | null;
  aiCommandId?: string | null;
};

/** Same completion branch and emit hosts; the caller passes its original input. */
export function trackNoteGenerationCompletedAnalytics(
  sessionId: string,
  input: CompletedGenerationAnalyticsInput
): void {
  if (input.isRegenerate) {
    noteSelectionRegenerateOutput();
  } else if (input.voiceStyle) {
    sessionVoiceUpdated({
      voiceStyle: input.voiceStyle,
      oldVoiceStyle: input.oldVoiceStyle,
      sessionId,
    });
  } else {
    switch (input.generationMethod) {
      case GenerationMethod.TEMPLATE:
        noteGeneratedByTemplate(input.templateId || '');
        sessionTemplateUpdated({
          templateId: input.templateId || '',
          sessionId,
        });
        break;
      case GenerationMethod.AI_COMMAND_TEXT:
        noteGeneratedByAskAI();
        break;
      case GenerationMethod.PRESET_AI_COMMAND:
        noteGeneratedByPressAICommand(input.aiCommandId || '');
        break;
    }
  }
}
